// extracted by mini-css-extract-plugin
module.exports = {"headline":"gallery_headline__6D_iC","subtitle":"gallery_subtitle__hk4cE","title":"gallery_title__sXKmJ","separator":"gallery_separator__gD9QQ"};